/**
 * Gestion de l'état du tableau de bord (Dashboard) pour les commandes.
 *
 * Ce module contient :
 * - filer_index_order : index appliqué au filtre actuel.
 * - slice_paginate_order : numéro de la page de pagination active.
 * - data_array_from_filter_order : tableau des données filtrées (ex : IDs ou pages disponibles).
 * - isNextStep_dialog : indique si la prochaine étape du dialogue/modale doit être affichée.
 *
 * Utilise ref() de Vue 3 pour gérer un état réactif simple.
 */
import { ref } from 'vue';

export const filer_index_order = ref(0);
export const slice_paginate_order = ref(1);
export const data_array_from_filter_order = ref<number[]>([1, 2, 3]);
export const isNextStep_dialog = ref(false);
